<button type="button" class="google-sign-in">
  <img [src]="googleImage.picGoogle" class="google-sign" alt="Google sign-in" />
  <span class="google-text-sign-in">
    {{ text | translate }}
  </span>
</button>
